import React, { type ReactElement } from 'react';
import clsx from 'clsx';
import styles from './index.module.scss';

type Props = {
  containerClassName?: string;
  className?: string;
  children: React.ReactNode;
};

export default function ErrorMessage({
  containerClassName,
  className,
  children
}: Props): ReactElement {
  return (
    <div className={clsx(containerClassName, styles.errorMessageContainer)}>
      <span className={clsx(className, styles.errorMessage)}>{children}</span>
    </div>
  );
}
